<!-- Light theme footer -->
<!-- <div class="layout">
  <div class="footer-main-light">
    <div class="footer-link-sec">
      <div class="comapny-logo">
        <img src="../../../assets/images/image 8.png" alt="" />
        <h2>FUTSAL OZ</h2>
      </div>

      <div class="link-blocks">
        <h5>Apps</h5>
        <ul>
          <li><a href=""> Android</a></li>
          <li><a href=""> iOS</a></li>
        </ul>
      </div>
      <div class="link-blocks">
        <h5>Follow US</h5>
        <ul>
          <li><a href=""> Facebook</a></li>
          <li><a href=""> Twitter</a></li>
          <li><a href=""> YouTube</a></li>
        </ul>
      </div>
      <div class="link-blocks">
        <h5>How to Join</h5>
        <ul>
          <li><a href=""> Create a Team </a></li>
          <li><a href=""> Become a Player </a></li>
        </ul>
      </div>
      <div class="link-blocks">
        <h5>Company</h5>
        <ul>
          <li><a href=""> Careers</a></li>
          <li><a href=""> Franchise</a></li>
          <li><a href=""> Advertise</a></li>
          <li><a href=""> About Us </a></li>
          <li><a href=""> Contact Us </a></li>
        </ul>
      </div>
    </div>
    <hr />
    <div class="copyright-sec">
      <p class="copyrights-text">copyrights 2022 @ futsaloz</p>
      <div class="termas-and-cond">
        <p class="terms-text">Terms & Condition</p>
        <div class="line"></div>
        <p class="terms-text">Privacy Policy</p>
      </div>
    </div>
  </div>
</div> -->

<!-- Dark theme footer -->
<div class="layout">
  <div class="footer-main-dark  footer-main-dark">
    <div class="footer-link-sec grid m-0">
      <div
        class="comapny-logo pointer xl:col-4 lg:col-4  col-12 lg:flex-column flex flex-row lg:align-items-start align-items-center "
        [routerLink]="['/']">
        <img src="../../../assets/images/FutsalOz 1.png" alt="" />
        <h2>FUTSAL OZ</h2>
      </div>
      <div class="xl:col-8 lg:col-8  col-12">
        <div class="grid p-0 m-0 justify-content-between">
          <div class="col-6 md:col-3  link-blocks">
            <h5>Apps</h5>
            <ul>
              <li><a href="https://play.google.com/store/apps/details?id=com.futsal.wefroth&hl=en_US" target="_blank">
                  Android</a></li>
              <li><a href="https://apps.apple.com/au/app/wefroth/id1482269666" target="_blank"> iOS</a></li>
            </ul>
          </div>
          <div class="col-6 md:col-3  link-blocks">
            <h5>Follow US</h5>
            <ul>
              <li><a href="https://www.facebook.com/futsaloz" target="_blank"> Facebook</a></li>
              <li><a href="https://twitter.com/futsaloz" target="_blank"> Twitter</a></li>
              <li><a href="https://www.instagram.com/futsaloz " target="_blank"> Instagram</a></li>
              <li><a href="https://www.youtube.com/c/futsalozau" target="_blank"> YouTube</a></li>
            </ul>
          </div>
          <div class="col-6 md:col-3  link-blocks">
            <h5>How to Join</h5>
            <ul>
              <li><a href="javascript:;" [routerLink]="['/create-team']"> Create a Team </a></li>
              <li><a href="javascript:;" [routerLink]="['/create-player']"> Become a Player </a></li>
            </ul>
          </div>
          <div class="col-6 md:col-3  link-blocks">
            <h5>Company</h5>
            <ul>
              <li><a href="javascript:;"> Careers</a></li>
              <li><a href="javascript:;" [routerLink]="['/venues']"> Venues</a></li>
              <li><a href="javascript:;" [routerLink]="['/franchise']"> Franchise</a></li>
              <li><a href="javascript:;"> Advertise</a></li>
              <li><a href="javascript:;" [routerLink]="['/about']"> About Us </a></li>
              <li><a href="javascript:;" [routerLink]="['/contact']"> Contact Us </a></li>
            </ul>
          </div>
        </div>

      </div>
    </div>
    <hr style="opacity:0.3 ;" class="hidden md:block" />
    <div class="copyright-sec grid m-0">
      <p class="copyrights-text col-12 md:col-6 text-center md:text-left">Copyright © 2026 FutsalOz Pty Ltd</p>
      <div class="termas-and-cond col-12 md:col-6 justify-content-center md:justify-content-end">
        <p class="terms-text"><a href="https://wefroth.com/privacy-policy.html">Terms & Condition</a></p>
        <div class="line"></div>
        <p class="terms-text"><a href="https://wefroth.com/terms-condition.html">Privacy Policy</a></p>
      </div>
    </div>
  </div>
</div>